import {TopEleven} from '../resources/TopEleven';
import {DomainEvent} from './DomainEvent';

export class TopElevenCreated extends DomainEvent<TopEleven> {}
